// @flow
import React, { useState, useEffect } from 'react';
import { Card } from '../../kit';
import TabHeader from './TabHeader';

type Props = {
  initialTab: Number,
  titles: Array,
  type?: String,
  hasRadius: Boolean,
  hasBorder: Boolean,
  borderColor: String,
  color?: String,
  wrapperClassName?: String,
  disabled?: Boolean,
};
const Tabs = React.forwardRef((props: Props, ref) => {
  const [tabIndex, setTabIndex] = useState(props.initialTab);

  const setIndex = (index) => {
    if ((!props.disabled || index < tabIndex) && index !== tabIndex)
      setTabIndex(index);
  };

  useEffect(() => {
    ref.current = { ...ref.current, forceSetIndex };
  }, []);

  const forceSetIndex = (index) => index !== tabIndex && setTabIndex(index);

  const renderTab = () =>
    props.children.find((child, index) => index === tabIndex);

  const {
    titles,
    type,
    hasRadius,
    hasBorder,
    borderColor,
    color,
    wrapperClassName,
    disabled,
  } = props;

  return (
    <div>
      <Card
        className={wrapperClassName}
        hasShadow={false}
        hasRadius={hasRadius}
        hasBorder={hasBorder}
        type={type}
      >
        <TabHeader
          color={color}
          borderColor={borderColor}
          titles={titles}
          tabIndex={tabIndex}
          setIndex={setIndex}
          disabled={disabled}
        />
      </Card>
      {renderTab()}
    </div>
  );
});

Tabs.defaultProps = {
  type: 'transparent',
  hasRadius: true,
  hasBorder: false,
  borderColor: 'lighterGray',
  disabled: false,
};

export default Tabs;
